import config from "@/config/app.config";

export const CALENDAR_SETTINGS = {
    droppable: true,
    initialView: 'timeGridWeek',
    headerToolbar: false,
    selectable: true,
    unselectCancel: '#fc-event-form',
    editable: true,
    // eventOverlap: false,
    eventResizableFromStart: true,
    eventDurationEditable: true,
    snapDuration: '00:05:00',
    contentHeight: 1000,
    dayHeaders: true,
    nowIndicator: true,
    selectConstraint: {
        startTime: '00:00',
        endTime: '24:00'
    },
}

export const TIMEGRID_SETTINGS = {
    allDaySlot: true,
    allDayHeaderContent: '',
    slotDuration: '00:15:00',
    // Only label the full hours (the grid itself still has a line every slotDuration)
    slotHeaderInterval: '01:00:00',
    eventShortHeight: 45,
    selectMirror: true,
    slotHeaderFormat: {
        hour: '2-digit',
        minute: '2-digit',
        omitZeroMinute: false,
    },
    // v7 no longer ships stable `.fc-*` class names, so styling hooks are attached through class options.
    dayLaneClass: (info: { isToday: boolean }) => info.isToday ? 'agenda-today' : '',
    slotLaneClass: (info: { time?: { milliseconds: number } }) =>
        info.time && info.time.milliseconds % 3600000 === 0 ? 'agenda-slot agenda-slot-hour' : 'agenda-slot',
    slotHeaderClass: 'agenda-slot-label',
    // Hooks for Agenda.vue's styles. FullCalendar joins these with the theme's own classes.
    // the outer frame of the grid (its top border scrolls away, so the day headers draw it instead)
    viewClass: 'agenda-view',
    // the day headers row: sticks below Agenda.vue's own sticky toolbar
    tableHeaderClass: 'agenda-day-headers',
    // the grid below the day headers (draws the lower part of the rounded frame)
    tableBodyClass: 'agenda-table-body',
    // each day header cell (FullCalendar centres its content instead of letting it fill the column)
    dayHeaderClass: 'agenda-day-header',
    // the content of each day header (the theme adds horizontal margins)
    dayHeaderInnerClass: 'agenda-day-header-inner',
    columnEventClass: 'agenda-event-column',
    rowEventClass: 'agenda-event-row',
    eventClass: (info: { isDragging: boolean }) => info.isDragging ? 'agenda-event-dragging' : '',
}
